import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'

import { Leaderboard } from 'partials/Leaderboard'
import { Page } from 'partials/Page'

import { useLeaderboard } from 'hooks/useLeaderboard'

export const LeaderboardPage = ({ navigation, route }: CompositeScreenProps<any, any>) => {
  const { trainerId } = route.params

  const { data: leaderboard, isLoading } = useLeaderboard({ trainerId })

  return (
    <Page
      navigation={navigation}
      withNav
      withBack
      isLoading={isLoading}
      title='Leaderboard'
      backgroundColor='white'
    >
      <Leaderboard users={leaderboard} showPositionNumber />
    </Page>
  )
}
